import {useInjex} from '@injex/react-plugin';
import ReportingModel from '../../model/reportingModel.mdl';

export default function useReportingModel(): ReportingModel {
    const [inject] = useInjex();
    return inject<ReportingModel>('reportingModel');
}
